import { ConversationRole } from '.';
export class Participant {
    constructor({ id, role = new ConversationRole([]) }) {
        this.id = void 0;
        this.role = void 0;
        this.id = id;
        this.role = role;
    }
}
